module.exports = "//img1.rrcimg.com/_next/static/src/assets/bj_2kurR.png";